import { render, staticRenderFns } from "./SVGShare.vue?vue&type=template&id=712c33b8&scoped=true&"
import script from "./SVGShare.vue?vue&type=script&lang=js&"
export * from "./SVGShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712c33b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('712c33b8')) {
      api.createRecord('712c33b8', component.options)
    } else {
      api.reload('712c33b8', component.options)
    }
    module.hot.accept("./SVGShare.vue?vue&type=template&id=712c33b8&scoped=true&", function () {
      api.rerender('712c33b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGShare.vue"
export default component.exports